/**
 * src/App.js
 * The storefront router. index.js decides whether to render this or
 * AdminSales — that logic is untouched. Everything below is new.
 */
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ShippingReturns from "./pages/ShippingReturns";
import OrderConfirmed from "./pages/OrderConfirmed";
import "./storefront.css";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:gender" element={<Shop />} />
        <Route path="/shop/:gender/:categorySlug" element={<Shop />} />
        <Route path="/shop/:gender/:categorySlug/:subcategorySlug" element={<Shop />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shipping-returns" element={<ShippingReturns />} />
        <Route path="/order-confirmed" element={<OrderConfirmed />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}